'use client';
import React from 'react';
import { ImageObj } from '@custom-types/ImageObj.types';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import SplideSlider from '@components/SplideSlider';
import AlGhadeerTitle from '@components-launch/AlGhadeer/AlGhadeerTitle';
import AlGhadeerParagraph from '@components-launch/AlGhadeer/AlGhadeerParagraph';
import cn from './style.module.scss';

type TabProps = {
  index: number;
  heading: string;
  description: string;
  images: Array<ImageObj>;
};

export default function AlGhadeerTabData(props: TabProps) {
  const { heading, index, description, images = [] } = props;
  const tabDataImageSliderProps = {
    type: 'slide',
    rewind: false,
    speed: 1000,
    pagination: true,
    arrows: true,
    autoplay: true,
    interval: 3000,
  };
  return (
    <Stack className={cn.alghadeerSpecificationData}>
      <Box component="article" className={cn.specificationDataInner}>
        <Box component="picture" className={cn.specificationDataTheme}>
          {images?.length > 1 ? (
            <SplideSlider options={tabDataImageSliderProps}>
              {images.map((imgObj, index) => (
                <Box
                  className={`${cn.specificationDataElement} ${''}`}
                  key={`${imgObj.name}_${index}`}
                  role="img"
                  aria-label={imgObj.alt || imgObj.name}
                >
                  <CustomImage
                    src={imgObj.url}
                    alt={imgObj.alt}
                    width={768}
                    height={768}
                  />
                </Box>
              ))}
            </SplideSlider>
          ) : (
            images?.length > 0 && (
              <Box className={`${cn.specificationDataElement} ${''}`}>
                <CustomImage
                  src={images[0]?.url}
                  alt={images[0]?.alt}
                  width={768}
                  height={768}
                />
              </Box>
            )
          )}
        </Box>
        <Box className={cn.specificationDataBlock}>
          <Box className={cn.specificationDataHeading}>
            <Box className={cn.specificationDataHeading__title}>
              <AlGhadeerTitle titleData={heading} />
            </Box>
            <Box className={cn.specificationDataHeading__data}>
              <AlGhadeerParagraph paragraphData={description} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
